import { ParameterType } from '@/study-search/enums';

import { EducationalFormFilterOptionValue } from '@studyportals/search-filters/server-side';
import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';

class ShortCoursesEducationalFormFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.EDUCATIONAL_FORM,
			[
				new FilterOptionInformation(
					'Academic Course',
					EducationalFormFilterOptionValue.ACADEMIC_COURSE,
					'academic-course',
					'Academic Course',
				),
				new FilterOptionInformation(
					'Conference/Seminar',
					EducationalFormFilterOptionValue.CONFERENCE_SEMINAR,
					'conference',
					'Conference/Seminar',
				),
				new FilterOptionInformation('Summer School', EducationalFormFilterOptionValue.SUMMER_SCHOOL, 'summer-school', 'Summer School'),
				new FilterOptionInformation('Winter School', EducationalFormFilterOptionValue.WINTER_SCHOOL, 'winter-school', 'Winter School'),
				new FilterOptionInformation(
					'Semester/Study Abroad',
					EducationalFormFilterOptionValue.SEMESTER_STUDY_ABROAD,
					'semester-abroad',
					'Semester/Study Abroad',
				),
				new FilterOptionInformation(
					'Skill/Professional Course',
					EducationalFormFilterOptionValue.SKILL_PROFESSIONAL_COURSE,
					'skill',
					'Skill/Professional Course',
				),
			],
			[
				EducationalFormFilterOptionValue.ACADEMIC_COURSE,
				EducationalFormFilterOptionValue.SUMMER_SCHOOL,
				EducationalFormFilterOptionValue.SEMESTER_STUDY_ABROAD,
				EducationalFormFilterOptionValue.SKILL_PROFESSIONAL_COURSE,
			],
		);
	}
}

export default new ShortCoursesEducationalFormFilterDefinition();
